export default __webpack_public_path__ + "static/media/filswan_icon.bf306d5f.jpg";